export default __webpack_public_path__ + "static/media/drawing-woman11-focusfill.63dd9edf.svg";